import { NETWORK_STATUS } from '@marketmuse/config/types';
import { SliceOptimizeNetworkStatus } from '../../../types';

export const initialState: SliceOptimizeNetworkStatus = {
  bulkAdwordsKeywords: NETWORK_STATUS.inactive,
  knowledgeGraph: NETWORK_STATUS.inactive,
  pageContents: NETWORK_STATUS.inactive,
};
